module.exports = __webpack_public_path__ + "img/twitter.c246c8aa.svg";